import { InjectionToken, Provider } from '@angular/core';

export const BUSINESS_FUNCTION_BANESCO = new InjectionToken<string[]>('BUSINESS_FUNCTION_BANESCO');
export const BusinessFunctionBanesco: Provider = {
  provide: BUSINESS_FUNCTION_BANESCO,
  useValue: [
    '1016',
    '1037',
    'banescoDR.1014',
    'banescoDR.1015',
    'banescoDR.1016',
    'banescoDR.1017',
    'banescoDR.1018',
    'banescoDR.1019',
    'banescoDR.1020',
    'banescoDR.1021',
    'banescoDR.1022',
    'banescoDR.1023',
    'banescoDR.1024',
    'banescoDR.1025',
    '1006',
    '1003',
    '1005',
    '1032',
    '1033',
    '1013',
    '1019',
    '1020',
    '1011',
    '1012',
    '1040',
    '1007',
    '1009',
    '1028',
    '1010',
    '1078',
    '1035',
    '1051',
    '1066',
    '1034',
    '1049',
    '1050',
    '1084',
    '1030',
  ],
};
